import { Popover } from "@/design-system/Popover/Popover";
import { SolutionStrategyTag } from "@/design-system/Tags/SolutionTag/SolutionTag";
import { useTranslation } from "@repo/shared/i18n";

import {
  AlternativeOptionRow,
  UnavailableOptionRow,
} from "./AlternativeOptionRow";
import { AlternativesPill } from "./AlternativesPill";
import { AlternativeRow, missingTags } from "./alternativeRow";

/* Wide enough for the meta line to stay on one row under the two figures. */
const PANEL_WIDTH = 460;

/**
 * Desktop: the alternatives in a panel off the pill, one per row so they
 * read down a single column and compare line for line. Same anchored popover
 * the player swaps use.
 */
export const AlternativesPanel = ({
  rows,
  allTags,
  currentId,
  onSelect,
  showTime = false,
  stretch = false,
}: {
  rows: AlternativeRow[];
  /** Every strategy the solver runs; the ones without a row show greyed. */
  allTags: SolutionStrategyTag[];
  currentId: string;
  onSelect: (id: string) => void;
  /** The build-time column, a Streamline idea. */
  showTime?: boolean;
  stretch?: boolean;
}) => {
  const { t } = useTranslation("sbcs");
  return (
    <Popover
      title={t("streamline.alternatives")}
      placement="bottom"
      align="end"
      width={PANEL_WIDTH}
      negLabel=""
      posLabel=""
      newDesignSystem
      trigger={(open) => <AlternativesPill open={open} stretch={stretch} />}
    >
      {(close) => (
        <div className="flex flex-col gap-2.5">
          {rows.map((row) => (
            <AlternativeOptionRow
              key={row.id}
              row={row}
              isCurrent={row.id === currentId}
              showTime={showTime}
              onSelect={() => {
                onSelect(row.id);
                close();
              }}
            />
          ))}
          {missingTags(rows, allTags).map((tag) => (
            <UnavailableOptionRow key={tag} tag={tag} showTime={showTime} />
          ))}
        </div>
      )}
    </Popover>
  );
};
